import React, { Fragment } from 'react'
import { host } from '../../configuraciones';
import axios from 'axios'

function BotonDescargarArchivos(props) {

    const formato = props.formato
    const componente = props.componente

    const botonDescargarArchivo = async () => {

        let fileFetch = null;
        let idSolicitud = null;
        switch (props.componente) {
            
            case 'fc01':
                idSolicitud = formato.idfc01_solicitudregistro
                fileFetch = await fetch(host + `FC_01/servirArchivosFC_01/${idSolicitud}`)
                break;
            case 'fc05':
                idSolicitud = formato.idfc05_solicitudusomarcaeimagen
                fileFetch = await fetch(host + `FC_05/servirArchivosFC_05/${idSolicitud}`)
                break;
            case 'fc08':
                idSolicitud = formato.idfc08_solicitudrenvacioncertif
                fileFetch = await fetch(host + `FC_08/servirArchivosFC_08/${idSolicitud}`)
                break;
            case 'fc09':
                idSolicitud = formato.idfc09_solicitudcertificado
                fileFetch = await fetch(host + `FC_09/servirArchivosFC_09/${idSolicitud}`)
                break;
            case 'fc33Principal':
                idSolicitud = formato.idfc33_solicitudenvasadonaciona
                fileFetch = await fetch(host + `FC_33/servirArchivosFC_33/${idSolicitud}`)
                break;
            case 'fc33Producto':
                idSolicitud = formato.idfc33_anexoproducto
                fileFetch = await fetch(host + `FC_33/servirArchivosFC_33Producto/${idSolicitud}`)
                break;
            case 'fc36':
                idSolicitud = formato.idfc36_solicitudactualizacion
                fileFetch = await fetch(host + `FC_36/servirArchivosFC_36/${idSolicitud}`)
                break;
            case 'fc40':
                idSolicitud = formato.idfc40_solicitudadquisicionholo
                fileFetch = await fetch(host + `FC_40/servirArchivosFC_40/${idSolicitud}`)
                break;
            case 'fc41':
                idSolicitud = formato.idfc41_solicitudparabebidasconm
                fileFetch = await fetch(host + `FC_41/servirArchivosFC_41/${idSolicitud}`)
                break;
            default:
                break;
        }

        if(fileFetch.status != 404){
            const blob = await fileFetch.blob();
            const url = window.URL.createObjectURL(new Blob([blob]), { type: 'application/zip' });
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${componente}.zip`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        }else {
            // alert('No hay archivos adjuntos')
        }
    }

    return (
    <Fragment>
            <div className='row text-center mt-5 mb-3'>
                <h4>Descargue los archivos en un comprimido ZIP<br></br> <button onClick={() => botonDescargarArchivo()} className='btn btn-success zoom mt-3'>Descargar .zip</button></h4>
                
            </div>
    </Fragment>
    )
}

export default BotonDescargarArchivos